import { Utilities } from "../../../utils/utilities";
import { DeviationData } from "../Deviation/DeviationData";
import { SubtaskData } from "../Deviation/SubtaskData";
import { FirebaseData } from "../General/FirebaseData";

export default class DeviationExternalLinkData extends FirebaseData {
  deviation?: DeviationData;
  tokenID: string = "";
  title: string = "";
  canUpdateStatus: boolean = false;
  canSendComment: boolean = false;
  canCreateTasks: boolean = false;
  tasks: "all" | SubtaskData[] = [];
  active: boolean = false;
  openCount: number = 0;
  lastOpen?: Date;
  openLogsDisabled: boolean = false;
  opens?: {
    date: Date;
  }[];

  setup(data: { [key: string]: any }) {
    this.tokenID = typeof data.tokenID === "string" ? data.tokenID : "";
    this.title = typeof data.title === "string" ? data.title : "";
    this.canUpdateStatus = typeof data.canUpdateStatus === "boolean" ? data.canUpdateStatus : false;
    this.canSendComment = typeof data.canSendComment === "boolean" ? data.canSendComment : false;
    this.canCreateTasks = typeof data.canCreateTasks === "boolean" ? data.canCreateTasks : false;

    if (typeof data.tasks === "object") {
      if (data.tasks.all === true) {
        this.tasks = "all";
      } else {
        this.tasks = [];
        for (let subtaskId in data.tasks) {
          if (this.deviation) {
            this.tasks.push(this.deviation.subtasks.addData(subtaskId));
          }
        }
      }
    }

    this.active = typeof data.active === "boolean" ? data.active : false;
    this.openCount = typeof data.openCount === "number" ? data.openCount : 0;
    this.lastOpen = Utilities.getDateFromTimestamp(data.lastOpen);
    this.openLogsDisabled = typeof data.openLogsDisabled === "boolean" ? data.openLogsDisabled : false;
    this.opens = Array.isArray(data.opens) ? data.opens : [];
  }
}

